export default "__VITE_PUBLIC_ASSET__15af8924__"